"use strict";

exports.__esModule = true;
exports.default = isBetween;
/** @module utils/NumberUtils/isBetween */

/**
 * Checks if a number is between a min and maximum (inclusive)
 *
 * @param {Number} num the number to check
 * @param {Number} min the minimum
 * @param {Number} max the maximum
 * @return {Boolean} true if the number is between the min and max (inclusive)
 */
function isBetween(num, min, max) {
  return num >= min && num <= max;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/utils/NumberUtils/isBetween.js
// module id = 348
// module chunks = 168707334958949